<template>
    <span :class="this.class" :id="this.id">{{ this.rate }}</span>
</template>

<script>
export default {
    name : 'cryptoRate',
    props: {
        cryptoKey : {
            type: String,
        },
        cryptoRate: {
            type: String,
        },
        class     : {
            type: String,
        },
        id        : {
            type: String,
        },
    },
    created() {
        this.subscribeToChanges();
        this.rate = this.cryptoRate;
    },
    data() {
        return {
            rate: 0.0
        }
    },
    methods: {
        subscribeToChanges: function () {
            window.Echo.channel('global')
                .listen('.GlobalCryptoRateChange', (e) => {
                    if (e.hasOwnProperty(this.cryptoKey)) {
                        this.rate = e[this.cryptoKey];
                    }
                });
        }
    }
}
</script>
